/**
 * Internationalization Configuration
 *
 * Central registry of all supported locales. This is the single source of truth
 * for which locales the application supports.
 *
 * To add a new country:
 * 1. Add its locale string to SUPPORTED_LOCALES
 * 2. Add its config to COUNTRY_CONFIG in country-config.ts
 * 3. Create translation files in public/locales/{locale}/
 */

export const SUPPORTED_LOCALES = [
  'en-US',
  'es-US',
  'en-CA',
  'fr-CA',
  'en-GB',
  'en-AU',
  'en-NZ',
  'en-SG',
  'en-NL',
  'en-SE',
  'en-DE',
  'de-DE',
  'en-DK',
  'en-FI',
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en-US';

/**
 * Type guard to check if a string is a supported locale
 */
export function isSupportedLocale(value: string): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/**
 * Extract the language code from a locale string (e.g., 'en-US' -> 'en')
 */
export function getLanguageFromLocale(locale: string): string {
  return locale.split('-')[0];
}

/**
 * Extract the country code from a locale string (e.g., 'en-US' -> 'US')
 */
export function getCountryCodeFromLocale(locale: string): string {
  return locale.split('-')[1] || '';
}
